import { ref } from "vue";

import type { ProductConfig } from "@/types/products/product-config";

import {
    bonusReportKey,
    majorIndexBreadthKey,
    portfolioBuilderKey,
    sectorAlertsKey,
    sectorsKey,
    sectorSpotlightKey,
    spLessonsKey,
    spProductKey,
    webinarKey
} from "@/types/products/product-definitions";

import { configureProductActionsMap, initializeProduct } from "@/composables/products/product-composition-helpers";

const initialView: string = sectorSpotlightKey;
const selectedView = ref<string>( initialView );

const productConfig: ProductConfig = {
    slug: spProductKey
}

const productActionTopicKeys = [
    bonusReportKey,
    sectorSpotlightKey,
    sectorAlertsKey,
    webinarKey,
    spLessonsKey,
    sectorsKey,
    majorIndexBreadthKey,
    portfolioBuilderKey
];

export function useSectorProphets() {
    const initialized = ref<boolean>( false );

    const logoPath = ref<string | undefined>( '' );
    const darkLogoPath = ref<string | undefined>( '' );

    const actionsMap = configureProductActionsMap( spProductKey, productActionTopicKeys );

    initializeProduct( productConfig.slug, initialized, logoPath, darkLogoPath );

    return {
        actionsMap,
        initialized,
        initialView,
        logoPath,
        darkLogoPath,
        selectedView
    }
}
